module.exports = __webpack_public_path__ + "media/components/assets/img/icons/bus-82c5ac24f8d9ea23eaf294063f8c171d.svg";